import axios from 'axios';
import Config from '../config/environments';
import { createSafeStrapi, isStrapiUrl } from '../utils/strapiErrorHandler';

export const createStrapiAxiosInstance = (options = {}) => {
  const axiosInstance = createSafeStrapi();
  
  if (options.timeout !== undefined) {
    axiosInstance.defaults.timeout = options.timeout;
  }
  
  return axiosInstance;
};



export const getStrapiData = async (url, options = {}) => {
  try {
    if (!isStrapiUrl(url)) {
      console.warn('URL não reconhecida como Strapi:', url);
    }
    
    const strapiAxios = createStrapiAxiosInstance(options);
    
    const response = await strapiAxios.get(url);
    
    return { data: response.data, error: null };
  } catch (error) {
    console.error('Erro ao obter dados do Strapi:', error.message || 'Erro desconhecido');
    return { data: null, error: error };
  }
};

export const processStrapiData = async (fetchFunction, processFunction, resourceName = 'recurso') => {
  try {
    const response = await fetchFunction();
    
    if (!response || !response.data) {
      console.warn(`Nenhum dado retornado para ${resourceName}`);
      return null;
    }
    
    return processFunction(response.data);
  } catch (error) {
    console.error(`Erro ao processar ${resourceName}:`, error.message || 'Erro desconhecido');
    return null;
  }
};